import React from "react";

const CountSecondaryIcon = React.forwardRef(
  (
    {
      variant = "solid",             
      width = 18,
      height = 19,
      brandColor = "#5062F0",        
      outlineColor = "#D0D3E2",       
      className,
      ...props
    },
    ref
  ) => {
    const isSolid = variant === "solid";

    const rectFill = isSolid ? brandColor : "none";
    const rectStroke = isSolid ? "#FFFFFF" : outlineColor;
    const rectStrokeWidth = isSolid ? 2 : 1;

    const lineStroke = isSolid ? "#FFFFFF" : outlineColor;
    const lineStrokeWidth = isSolid ? 1.2 : 0.6;

    const cap = "round";
    const join = "round";

    const linesY = ["3.83203", "6.10156", "8.36719", "10.6328", "12.8984", "15.168"];

    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          d="M1 3C1 1.89543 1.89543 1 3 1H12H15C16.1046 1 17 1.89543 17 3V5.25V16C17 17.1046 16.1046 18 15 18H3C1.89543 18 1 17.1046 1 16V3Z"
          fill={rectFill}
          stroke={rectStroke}
          strokeWidth={rectStrokeWidth}
          strokeLinecap={cap}
          strokeLinejoin={join}
        />

        {linesY.map((y) => (
          <path
            key={y}
            d={`M4.99951 ${y}L12.9995 ${y}`}
            stroke={lineStroke}
            strokeWidth={lineStrokeWidth}
            strokeLinecap={cap}
            strokeLinejoin={join}
          />
        ))}
      </svg>
    );
  }
);

export default React.memo(CountSecondaryIcon);
